import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { ListingFormView } from '../ListingEditForm/view';
import { LISTING_CREATE, S3_UPLOAD_REQUEST } from 'const/mutations';
import { APP_QUERY } from 'const/queries';
import { useMemo } from 'react';

export function ListingCreateForm() {
    const navigate = useNavigate();
    const { id: appId } = useParams<{ id: string }>();

    const { data } = useQuery(APP_QUERY, { variables: { id: appId } });
    const app = data && data.app;

    const listing = useMemo(
        () => ({
            appId: appId,
            name: '',
            tagLine: '',
            description: '',
            supportEmail: '',
            supportPhone: '',
            websiteUrl: '',
            privacyPolicyUrl: '',
            promoVideoUrl: '',
            searchTerms: [],
            integrations: [],
            includeKeyBenefitsImages: false,
            icon: null,
            keyBenefits: [],
            screenShots: [],
            pricePlans: [],
            showContactDetails: false,
            offerDemoRequest: false,
        }),
        [appId]
    );

    const [s3UploadRequestMutation] = useMutation(S3_UPLOAD_REQUEST);

    const [listingCreate, { loading }] = useMutation(LISTING_CREATE, {
        onCompleted() {
            navigate('/extranet/apps/' + appId + '/dashboard');
        },
    });

    const onSubmit = (values, form, callback) => {
        values.appId = appId;
        listingCreate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate('/extranet/apps/' + appId + '/dashboard');
    };

    return (
        <ListingFormView
            app={app}
            listing={listing}
            s3UploadRequestMutation={s3UploadRequestMutation}
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
        />
    );
}
